import React from 'react'
import { Collapse } from 'react-bootstrap'
import { ArrowIcon } from '../Icons/ArrowIcon'
import { colors } from '../../styles/colors'
import styled from 'styled-components'
import { useWithdrawalsState } from '../../stores/WithdrawalsProvider'
import { StyledItemWrapper } from '../TreeList/treeList'
import { useTranslation } from 'react-i18next'
import StorehouseFilter from '../Filter/StorehouseFilter'
import CostCenterFilter from '../Filter/CostCenterFilter'
import OfficeFilter from '../Filter/OfficeFilter'
import DateRangeFilter from '../Filter/DateRangeFilter'
import OrderProcessTypeFilter from '../Filter/OrderProcessTypeFilter'
import PickingProcessFilter from './PickingProcessFilter'


const StyledCollapseWrapper = styled.div`
  margin-bottom: 25px;
 

  ${StyledItemWrapper} {
    background-color: #FFF;
  }

`

const StyledFilterToggle = styled.h2`
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${colors.gray5};
  font-size: 20px;
  margin-bottom: 10px;
  ${ArrowIcon} {
    margin-right: 10px;
  }
`

const OverlayLeftFilter = () => {
    const {
        openOrderProcessTypeFilter, setOpenOrderProcessTypeFilter, orderProcessTypeFilter, setOrderProcessTypeFilter,
        openStorehouseFilter, setOpenStorehouseFilter,
        storehouseFilter, setStorehouseFilter,
        openDateRangeFilter, setOpenDateRangeFilter,
        startDateFilter, setStartDateFilter,
        endDateFilter, setEndDateFilter,
        openOfficeFilter, setOpenOfficeFilter, setOfficeFilter, setOfficeName,
        openCostCenterFilter, setOpenCostCenterFilter, setCostCenterFilter, setCostCenterName,
        pickingProcessFilter, setPickingProcessFilter, openPickingProcessFilter, setOpenPickingProcessFilter
    } = useWithdrawalsState()
    const { t } = useTranslation()

    return (
        <>
            <StyledCollapseWrapper>
                <StyledFilterToggle onClick={() => setOpenOfficeFilter(!openOfficeFilter)} aria-controls="office-collapse"
                    aria-expanded={openOfficeFilter}>
                    <ArrowIcon variant={openOfficeFilter ? 'down' : 'right'} color={colors.gray5} />{t('orgaUnit')} ({t('orgaUnitShortcut')})
                </StyledFilterToggle>
                <Collapse in={openOfficeFilter}>
                    <div id="office-collapse">
                        {openOfficeFilter && <OfficeFilter setOfficeFilter={setOfficeFilter} setOfficeName={setOfficeName} />}
                    </div>
                </Collapse>
            </StyledCollapseWrapper>
            <StyledCollapseWrapper>
                <StyledFilterToggle onClick={() => setOpenCostCenterFilter(!openCostCenterFilter)}
                    aria-controls="costCenter-collapse" aria-expanded={openCostCenterFilter}>
                    <ArrowIcon variant={openCostCenterFilter ? 'down' : 'right'} color={colors.gray5} />{t('costcenter')} ({t('costcenterShortcut')})
                </StyledFilterToggle>
                <Collapse in={openCostCenterFilter}>
                    <div id="costCenter-collapse">
                        {openCostCenterFilter && <CostCenterFilter setCostCenterFilter={setCostCenterFilter} setCostCenterName={setCostCenterName} />}
                    </div>
                </Collapse>
            </StyledCollapseWrapper>
            <StyledCollapseWrapper>
                <StyledFilterToggle onClick={() => setOpenStorehouseFilter(!openStorehouseFilter)}
                    aria-controls="storehouse-collapse" aria-expanded={openStorehouseFilter}>
                    <ArrowIcon variant={openStorehouseFilter ? 'down' : 'right'} color={colors.gray5} />{t('withdrawalsTable:warehouse')} ({t('withdrawalsTable:warehouseShortcut')})
                </StyledFilterToggle>
                <Collapse in={openStorehouseFilter}>
                    <div id="storehouse-collapse">
                        <StorehouseFilter storehouseFilter={storehouseFilter} setStorehouseFilter={setStorehouseFilter} />
                    </div>
                </Collapse>
            </StyledCollapseWrapper>
            <StyledCollapseWrapper>
                <StyledFilterToggle onClick={() => setOpenOrderProcessTypeFilter(!openOrderProcessTypeFilter)}
                    aria-controls="orderProcessType-collapse" aria-expanded={openOrderProcessTypeFilter}>
                    <ArrowIcon variant={openStorehouseFilter ? 'down' : 'right'} color={colors.gray5} />{t('withdrawalsTable:orderProcessType')} ({t('withdrawalsTable:orderProcessTypeShortcut')})
                </StyledFilterToggle>
                <Collapse in={openOrderProcessTypeFilter}>
                    <div id="orderProcessType-collapse">
                        <OrderProcessTypeFilter orderProcessTypeFilter={orderProcessTypeFilter} setOrderProcessTypeFilter={setOrderProcessTypeFilter} />
                    </div>
                </Collapse>
            </StyledCollapseWrapper>
            <StyledCollapseWrapper>
                <StyledFilterToggle onClick={() => setOpenDateRangeFilter(!openDateRangeFilter)}
                    aria-controls="dateRange-collapse" aria-expanded={openDateRangeFilter}>
                    <ArrowIcon variant={openDateRangeFilter ? 'down' : 'right'} color={colors.gray5} />{t('withdrawalsTable:orderDate')}
                </StyledFilterToggle>
                <Collapse in={openDateRangeFilter}>
                    <div id="dateRange-collapse">
                        <DateRangeFilter dateFrom={startDateFilter} setDateFrom={setStartDateFilter} dateTo={endDateFilter} setDateTo={setEndDateFilter} />
                    </div>
                </Collapse>
            </StyledCollapseWrapper>
            <StyledCollapseWrapper>
                <StyledFilterToggle onClick={() => setOpenPickingProcessFilter(!openPickingProcessFilter)}
                    aria-controls="pickingprocess-collapse" aria-expanded={openPickingProcessFilter}>
                    <ArrowIcon variant={openPickingProcessFilter ? 'down' : 'right'} color={colors.gray5} />{t('withdrawalsTable:status')}
                </StyledFilterToggle>
                <Collapse in={openPickingProcessFilter}>
                    <div id="pickingprocess-collapse">
                    <PickingProcessFilter pickingProcessFilter={pickingProcessFilter} setPickingProcessFilter={setPickingProcessFilter} />
                    </div>
                </Collapse>
            </StyledCollapseWrapper>
        </>
    )
}

export default OverlayLeftFilter
